import { MedicineSearchResultData } from '../models/api-models';

let cache: MedicineSearchResultData[] | null = null;
let fetchPromise: Promise<MedicineSearchResultData[]> | null = null;

export const loadMedicines = (): Promise<MedicineSearchResultData[]> => {
    if (cache) return Promise.resolve(cache);
    if (fetchPromise) return fetchPromise;
    fetchPromise = fetch('/medicines.json')
        .then(r => r.json())
        .then((data: MedicineSearchResultData[]) => {
            cache = data;
            fetchPromise = null;
            return data;
        });
    return fetchPromise;
};

export const searchMedicines = (query: string): MedicineSearchResultData[] => {
    if (!cache || !query.trim()) return [];
    const q = query.toLowerCase();
    const results: MedicineSearchResultData[] = [];
    for (const m of cache) {
        if (
            m.designacao.toLowerCase().includes(q) ||
            m.substanciaActiva.toLowerCase().includes(q)
        ) {
            results.push(m);
            if (results.length === 50) break;
        }
    }
    return results;
};
